const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawMessengerRe8Bky(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.75,31.1a4.59,4.59,0,0,0-4.35,3.14H224.89a4.62,4.62,0,1,0,0,2.95H450.4a4.6,4.6,0,1,0,4.35-6.09Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.22,38c3.22,78.18,6,157.11,9.39,235l-.33,15.27s-14.45,0-22.06.76-19.4.76-27.77.76-12.93-3.05-12.93-3.05l.55-13.76c1.68-77.86,3.51-156.8,4.69-235",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.19,
    y1: 260.11,
    x2: 242.15,
    y2: 269.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 242.98,
    y1: 80.75,
    x2: 242.23,
    y2: 251.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.17,
    y1: 36.29,
    x2: 243,
    y2: 75.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.14,
    y1: 126.21,
    x2: 254.41,
    y2: 240.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.48,
    y1: 37.31,
    x2: 256.24,
    y2: 119.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 268.24,
    y1: 157.91,
    x2: 268.72,
    y2: 263.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.9,
    y1: 82.79,
    x2: 268.2,
    y2: 149.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 267.7,
    y1: 38.33,
    x2: 267.86,
    y2: 74.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.89,38c-3.09,82.78-7,166.39-10,248.73a138.9,138.9,0,0,0,16.18,1.49h32.31a93.14,93.14,0,0,0,14.95-1.54c-1.45-82.29-2.44-165.9-5-248.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.92,
    y1: 260.11,
    x2: 430.96,
    y2: 269.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430.14,
    y1: 80.75,
    x2: 430.89,
    y2: 251.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 429.94,
    y1: 36.29,
    x2: 430.11,
    y2: 75.64,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.98,
    y1: 126.21,
    x2: 418.7,
    y2: 240.18,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.63,
    y1: 37.31,
    x2: 416.87,
    y2: 119.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.87,
    y1: 157.91,
    x2: 404.39,
    y2: 263.69,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.21,
    y1: 82.79,
    x2: 404.91,
    y2: 149.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 405.41,
    y1: 38.33,
    x2: 405.25,
    y2: 74.62,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "279.66 60.24 302.35 60.24 302.35 86.72 281.17 86.72",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.31,
    y: 60.3,
    width: 23.72,
    height: 26.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "393.76 60.24 371.07 60.24 371.07 86.72 392.25 86.72",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.39,
    y: 60.3,
    width: 23.72,
    height: 26.56,
    transform: "translate(710.5 147.16) rotate(180)",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    points: "283.4 180.55 330.64 180.55 330.64 101.17 281.33 101.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "391.37 100.5 343.1 100.5 343.1 180.55 387.74 180.55",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "284.96 199.39 330.64 199.39 330.64 279.19 288.42 279.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "388.26 198.72 343.1 198.72 343.1 279.93 384.27 279.93",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 288.21,
    y1: 285,
    x2: 384.9,
    y2: 285,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.47,
    y1: 51.05,
    x2: 393.71,
    y2: 51.05,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 336.86,
    y1: 51.6,
    x2: 336.86,
    y2: 283.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.92,
    y1: 95.03,
    x2: 392.04,
    y2: 95.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.87,147.22V112.3h-3.16V67.6A27.55,27.55,0,0,0,218.16,40h-148A27.56,27.56,0,0,0,42.59,67.6V368.34A27.56,27.56,0,0,0,70.15,395.9h148a27.55,27.55,0,0,0,27.55-27.56V177h3.16V156.35h-3.16v-9.13Z",
    style: {
      fill: "#707070",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.78,
    y: 43.84,
    width: 196.74,
    height: 348.26,
    rx: 30.52,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5,46.34H154.86l-.06.2c-1.61,5.82-5.34,9.6-9.46,9.6H143c-4.13,0-7.85-3.78-9.47-9.6l-.05-.2H78.81A27.56,27.56,0,0,0,51.25,73.9V348.66a27.55,27.55,0,0,0,27.56,27.55H209.5a27.54,27.54,0,0,0,27.55-27.55V73.9A27.55,27.55,0,0,0,209.5,46.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.5,46.34H154.86l-.06.2c-1.61,5.82-5.34,9.6-9.46,9.6H143c-4.13,0-7.85-3.78-9.47-9.6l-.05-.2H78.81A27.56,27.56,0,0,0,51.25,73.9V77h185.8V73.9A27.55,27.55,0,0,0,209.5,46.34Z",
    style: {
      fill: "#076760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.79,202c0-6,8.18-13.06,6.7-18.62-1.54-5.75-12.19-7.74-15.1-12.78s.61-15.31-3.54-19.46-14.34-.57-19.46-3.53-7-13.56-12.77-15.1c-5.56-1.48-12.59,6.7-18.62,6.7s-13.06-8.18-18.62-6.7c-5.75,1.54-7.74,12.19-12.78,15.1s-15.31-.61-19.46,3.54-.57,14.34-3.53,19.46-13.56,7-15.1,12.77C72,188.94,80.21,196,80.21,202s-8.18,13.06-6.7,18.62c1.54,5.75,12.19,7.74,15.1,12.78s-.61,15.31,3.54,19.46,14.34.57,19.46,3.53,7,13.56,12.77,15.1c5.56,1.48,12.59-6.7,18.62-6.7s13.06,8.18,18.62,6.7c5.75-1.54,7.74-12.19,12.78-15.1s15.31.61,19.46-3.54.57-14.34,3.53-19.46,13.56-7,15.1-12.77C214,215.06,205.79,208,205.79,202Z",
    style: {
      fill: "#076760"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.13,227.16,115,198.44a3.42,3.42,0,0,1,5-4.7L141.3,216.3l26.9-39a3.43,3.43,0,1,1,5.64,3.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,303.88l-.82.83-5.64,5.64-6.48-6.47a4,4,0,0,1,0-5.64,4,4,0,0,1,5.64,0l.84.83.82-.83a4,4,0,0,1,5.64,0A4,4,0,0,1,72.15,303.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.88,
    cy: 303.98,
    r: 8.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.06,305.49a4.75,4.75,0,0,0,4.82,3.89,4.53,4.53,0,0,0,4.82-3.89Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.92,302.46c0,.94-.28,1.7-.62,1.7s-.62-.76-.62-1.7.28-1.71.62-1.71S85.92,301.51,85.92,302.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.57,302.46c0,.94-.28,1.7-.62,1.7s-.62-.76-.62-1.7.28-1.71.62-1.71S90.57,301.51,90.57,302.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.38,
    y1: 320.5,
    x2: 116.5,
    y2: 320.5,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162.33,
    y1: 328,
    x2: 181.67,
    y2: 328,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.33,
    y1: 328,
    x2: 158.33,
    y2: 328,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.33,
    y1: 328,
    x2: 141.67,
    y2: 328,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.38,
    y1: 328,
    x2: 93,
    y2: 328,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.33,
    y1: 336,
    x2: 170,
    y2: 336,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: 336,
    x2: 127.67,
    y2: 336,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.38,
    y1: 336,
    x2: 94.33,
    y2: 336,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 219.67,
    y1: 344,
    x2: 224.33,
    y2: 344,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 185,
    y1: 344,
    x2: 216.33,
    y2: 344,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.67,
    y1: 344,
    x2: 177,
    y2: 344,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 344,
    x2: 118.33,
    y2: 344,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.38,
    y1: 344,
    x2: 67.67,
    y2: 344,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.87,
    cy: 102.67,
    r: 10.96,
    style: {
      fill: "#595959"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.31,
    y1: 103.17,
    x2: 125.18,
    y2: 103.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.59,
    cy: 47.66,
    r: 2.59,
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.76,57.58c0,2.61-2.93,3.56-3,5.55v.14h2.86v.88H63.86v-.74c0-2.81,2.94-3.35,2.94-5.8,0-.89-.3-1.36-1-1.36s-1,.51-1,1.28v.77h-.9v-.71c0-1.33.61-2.21,2-2.21S67.76,56.25,67.76,57.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.52,57.56v.23a1.72,1.72,0,0,1-1.06,1.78,1.74,1.74,0,0,1,1.06,1.8V62c0,1.33-.62,2.2-2,2.2s-2-.87-2-2.2v-.59h.91v.65c0,.78.32,1.26,1,1.26s1-.46,1-1.34v-.67c0-.86-.36-1.27-1.09-1.29h-.52v-.87h.57a1,1,0,0,0,1-1.19v-.4c0-.89-.31-1.35-1-1.35s-1,.48-1,1.26V58h-.91v-.4c0-1.32.62-2.18,2-2.18S72.52,56.24,72.52,57.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,58.22v1.2h-.93v-1.2Zm0,4.73v1.2h-.93V63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.35,59a1.4,1.4,0,0,1,1.29-.72c1.12,0,1.61.82,1.61,2.06V62c0,1.33-.63,2.2-2,2.2s-1.94-.87-1.94-2.2v-.58h.9v.64c0,.78.32,1.26,1,1.26s1-.48,1-1.26V60.42c0-.78-.33-1.26-1-1.26a.94.94,0,0,0-1,.93v.2h-.91l.24-4.82H79v.87H76.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.08,57.55v.16h-.91v-.22c0-.78-.32-1.24-1-1.24s-1.06.47-1.06,1.4v2a1.4,1.4,0,0,1,1.4-.93c1.12,0,1.61.8,1.61,2.06V62c0,1.33-.65,2.2-2,2.2s-2-.87-2-2.2V57.61c0-1.37.62-2.23,2-2.23S84.08,56.22,84.08,57.55Zm-3,3.25v1.3c0,.78.32,1.26,1,1.26s1-.48,1-1.26V60.8c0-.78-.34-1.25-1-1.25S81.09,60,81.09,60.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.41,
    y: 57.93,
    width: 2.45,
    height: 6.13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.68,
    y: 56.7,
    width: 2.45,
    height: 7.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.95,
    y: 55.83,
    width: 2.45,
    height: 8.23,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.22,
    y: 54.32,
    width: 2.45,
    height: 9.74,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,63.89H204.3v-9H219Zm-13.9-.81h13.08V55.72H205.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.34,
    y: 56.61,
    width: 7.76,
    height: 5.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.5,
    y: 58.34,
    width: 1.85,
    height: 2.12,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,61.94a.6.6,0,0,1-.28-.08c-3-1.78-5-.13-5.05-.06a.55.55,0,1,1-.72-.82c.1-.1,2.63-2.26,6.34-.06a.55.55,0,0,1,.19.75A.57.57,0,0,1,198.9,61.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,60.09a.5.5,0,0,1-.28-.08c-4.33-2.57-7.24-.08-7.27-.06a.53.53,0,0,1-.77-.05.54.54,0,0,1,.05-.77s3.54-3,8.55-.06a.54.54,0,0,1,.19.75A.53.53,0,0,1,200,60.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,58a.53.53,0,0,1-.28-.07c-5.49-3.26-9.13-.2-9.28-.06a.55.55,0,0,1-.73-.83c.05,0,4.38-3.74,10.57-.06a.55.55,0,0,1,.19.75A.54.54,0,0,1,201,58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.25,62.86a1.38,1.38,0,1,1-1.38-1.38A1.38,1.38,0,0,1,197.25,62.86Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.21,296s-3.71,22.07-1,34.73,8.38,29.3,9,31.93-2.09,14.29-1,22.92,3.58,35.76,3.58,35.76-.46,6.76.57,8.41a10,10,0,0,1,1.41,5.24c.08,1.93-1.29,3.91,0,5.3s2.27,2.56,2.33,4,.11,2.88.15,3.84-7.47,12.1-7.34,15.47,3,3.5,7.07,2.13,7.65-7.53,7.65-7.53l.36,2.88a1.27,1.27,0,0,0,1.65-.79,20.71,20.71,0,0,0,.27-5.31c0-1,.85-2.92.73-6.05a44.77,44.77,0,0,0-1-6.95s.85-2.92,1-4.13-1-2.13-.2-5.29,2-3.22,2-5.14a22.17,22.17,0,0,0-.71-5.76c-.54-1.66,1.8-15.48,1.73-17.41s.19-7.23.19-7.23,2.56-8.54,2.43-11.9-.29-25.53-.29-25.53l-.32-8.18s.72,12,2.17,18.47,4.12,24.89,5.72,28.92,3.91,13.58,4.78,17.4,2.13,11.24,2.13,11.24a11,11,0,0,0-.29,4.83,21.07,21.07,0,0,0,.63,3.83s-1.55,3.43-1.27,4.38a34,34,0,0,1,.43,4.81c0,.72-1.55,3.43-2.84,7.58s-5.66,9.13-1.89,13.08,10.21-3.78,11.25-7.91,3.4-11.7,3.61-12.43a13.87,13.87,0,0,0,1.72-5.13,24.52,24.52,0,0,0,0-5.54,23.16,23.16,0,0,0,1-4.14c.17-1.69,0-5.3,0-5.3s3.7-16,4-21.35-1.61-16.32-1.93-18.24,0-6.5-.79-7.91-2.41-6.17-2.41-6.17,12-26.73,13.79-41.26,1.13-26.54.31-28.92-1.62-4.51-1.62-4.51-10.08,7.14-31.88,4.14-30.28-4.1-32.47-4.74A15.29,15.29,0,0,0,286.21,296Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.67,149s-5.77.48-11.29,7.24-8.19,15.67-6.58,18.12,3.53,6.66,3.57,7.66-7.47,8.35-5.33,11.53,2.72,5.18,1,5.5-4.66,2.95-4.09,4.69,3.64,3.13,2.47,5.19-2.19,1.84-2.1,4.36,2.58,4.44,1.27,4.86-3.8,1-3,2.75a23.12,23.12,0,0,0,2.67,3.92s9.69,9.68,28.87,11.19,36.87-15.79,39.53-18.41,3.14-3.4,3.08-4.9-1.13-3.23-1.71-5,.05-5.28,0-6-1.87-2.69-3.17-3.64-1.65-3.71-1.25-6.25-2.18-4.19-3.21-4.9-1.88-2.95-1.21-5.24-2.44-4.43-3.74-5.38-1.63-3.21-1.23-5.74-3.07-7.68-4.92-9.87-4.39-9.39-14.06-12S306.67,149,306.67,149Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.92,202.88s-10.83,6.2-18.2,8.66-7.69,18.86-7.53,22.94-3.9,29.55-1.36,32.82,25.64,2.6,33.57,2.05,13.53,1.15,18.75-1,5.87-3.84,5.77-6.49.44-31.57.22-37.11-1.73-13.42-3.72-15-6.14-2.89-12.23-4.57S318.92,202.88,318.92,202.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.54,276.55s-4,20.87-3.92,22.79a21.73,21.73,0,0,1-.32,4.11s8.78,2.55,12.4,2.89,11.59.5,15,1.33,17.59,0,22.6-1.13,8.59-2.26,11.44-3.1a62.48,62.48,0,0,0,6.88-2.68l2.82-2-5.91-21.44s-10.29,1.61-20.38,2.48-29.21-1.5-31.87-1.87S289.54,276.55,289.54,276.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.57,
    y1: 293.4,
    x2: 298.28,
    y2: 296.12,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.83,
    y1: 281.47,
    x2: 298.82,
    y2: 291.05,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 298.26,
    y1: 282.07,
    x2: 295.92,
    y2: 290.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 331.15,
    y1: 282.36,
    x2: 330.8,
    y2: 293.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.19,
    y1: 294.02,
    x2: 339.69,
    y2: 297.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 337.22,
    y1: 281.59,
    x2: 338.69,
    y2: 290.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.92,261.88c-.11-2.64.44-31.57.22-37.11-.11-2.79-.37-1.68-1-4.56-3.5,3.28-11.25,8.7-26.5,10.46a48.37,48.37,0,0,1-28.88-5.84,58.09,58.09,0,0,0-.53,9.65c.16,4.09-3.9,29.55-1.36,32.82s25.64,2.6,33.57,2.05,13.53,1.15,18.75-1S350,264.53,349.92,261.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,261.05a67.17,67.17,0,0,0,7.58-1.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,259.77A93.3,93.3,0,0,0,321,261.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.49,256.52a11,11,0,0,0,9.57,4.44",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65,258.49a16.47,16.47,0,0,0,4.19,2.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.21,260.37a22.26,22.26,0,0,0,4.35-5.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,265.93s21.83,3.72,32.65,3.29,27.23-5.89,27.23-5.89l.79,13.95s-9.67,5.19-29.89,5.51-31.69-3.33-31.69-3.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.84,217.89s-.23-6-.45-11.55a30.88,30.88,0,0,0-1-7.9,30.89,30.89,0,0,0,7.77,1.38c3.86.08,9.64-5.92,10.08-6.91s1.1-2.69,1.1-2.69.61,9.37,1.48,12.95,1.43,5.73,1.43,5.73",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.38,208c5.86-3.22,10.91-10.69,10.91-10.69l.34-2.53c-2.08,2.1-5.78,5.1-8.51,5a30.89,30.89,0,0,1-7.77-1.38,30.88,30.88,0,0,1,1,7.9c.05,1.25.1,2.52.14,3.74C311.48,209.58,312.72,208.91,314.38,208Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,173.45l-3.84.4s-.08-.55-.31-1.44l-.49-.46c-.75-.69-1-.44-2.19-.64s-1.77-2.09-1.85-4-2.5-2.31-5.22-4.13c-2.23-1.49-3.23-4.64-3.52-5.74a16.62,16.62,0,0,0-2.7-.1,17.34,17.34,0,0,1-2.22,5.69c-1.82,2.72-3.51,2.55-3.93,4s-1.56,3.19-2.52,3.47-3.35.38-3.31,1.58-.59,3.15-1.3,3.66l-.53.39c.43,2.71,1,4.9,1,5.38,0,1,.28,7.21,3.07,10.72s8.15,11.24,14.41,11,11.21-8.87,12.09-11.07,1.11-8.48,1.11-8.48a14.09,14.09,0,0,0,3-4.45C333.79,176.51,332,173.45,332,173.45Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.22,172.62c-.07-1.69,1.5-4.64,2.22-4.67a6.19,6.19,0,0,0,3.51-2.79c.43-1.22.14-2.41,1.33-2.94s1.11-2.21,1.11-2.21-3.23,3.5-5.12,4.54a11.53,11.53,0,0,0-3.5,2.78,22.44,22.44,0,0,0,0,6.51A1.36,1.36,0,0,0,298.22,172.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.7,190.63s1.52,2.11,4.35.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.84,194.24s4.89,1.74,6.67-2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.76,181.7c.14,1-.18,1.85-.71,1.92S305,183,304.86,182s.18-1.84.7-1.92S306.63,180.71,306.76,181.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.75,180.15c.13,1-.18,1.84-.71,1.91s-1.07-.67-1.2-1.65.18-1.85.71-1.92S318.61,179.16,318.75,180.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.56,178s1.12-2.21,5-1.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,175.33s3.78-1.84,6.76.46",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.29,176.59s3.26,3.25,3.39,6.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.42,309s-3.95,3.77-4.79,13-.84,27.74-.84,27.74.6,6.11.87,9.84",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.35,314.35a18.18,18.18,0,0,1-3.55-3.28",
    style: {
      fill: "none",
      stroke: "gray",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.87,403.79c1.26,4.39,2.54,9.74,3.14,12.37.87,3.82,2.13,11.24,2.13,11.24a11,11,0,0,0-.29,4.83,21.07,21.07,0,0,0,.63,3.83s-1.55,3.43-1.27,4.38a34,34,0,0,1,.43,4.81c0,.72-1.55,3.43-2.84,7.58s-5.66,9.13-1.89,13.08,10.21-3.78,11.25-7.91,3.4-11.7,3.61-12.43a13.87,13.87,0,0,0,1.72-5.13,24.52,24.52,0,0,0,0-5.54,23.16,23.16,0,0,0,1-4.14c.17-1.69,0-5.3,0-5.3s3.7-16,4-21.35a33.94,33.94,0,0,0-.06-3.57A35.84,35.84,0,0,1,325.87,403.79Z",
    style: {
      fill: "#595959",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,458.16l.36,2.88a1.27,1.27,0,0,0,1.65-.79,20.71,20.71,0,0,0,.27-5.31c0-1,.85-2.92.73-6.05a44.77,44.77,0,0,0-1-6.95s.85-2.92,1-4.13-1-2.13-.2-5.29,2-3.22,2-5.14a22.17,22.17,0,0,0-.71-5.76c-.54-1.66,1.8-15.48,1.73-17.41,0-.6,0-1.53,0-2.53-6.39,2.43-14.41,1.39-19.5.27,1,9.64,1.85,19.34,1.85,19.34s-.46,6.76.57,8.41a10,10,0,0,1,1.41,5.24c.08,1.93-1.29,3.91,0,5.3s2.27,2.56,2.33,4,.11,2.88.15,3.84-7.47,12.1-7.34,15.47,3,3.5,7.07,2.13S308.5,458.16,308.5,458.16Z",
    style: {
      fill: "#595959",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.19,207.56s-5.27,13-6.79,23.15-4,27.86-5,31.27-3.81,7.38-7.16,26.3-1,41-1,41-.93,1-5.05.44a37.58,37.58,0,0,1-8.28-2.33s1.57-21.26,3.43-29,6.2-26.26,6.2-26.26l-.11-8.91A76.55,76.55,0,0,1,281.49,274c-2.7,4.69-5.52,6.48-10.09,6.66s-7.8-8.36-4.72-15.71,6.08-16.86,7.81-22,7.1-21.48,11.07-24.77S308.25,207.15,310.19,207.56Z",
    style: {
      fill: "#076760",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332,204.29s-1,29.19.59,39.48,7.18,23.33,8.84,28.81,3.64,25.15,5.14,32.56,1,25.25,1,25.25,3.85-.15,6.27,0,12.08-5.06,12.08-5.06-1.25-13.44-3.78-22.73-7.4-28.86-8.05-33.17-1.81-9.09-1.86-10.53,2-10,2-10,7.37-21,6.62-27.72-9.33-10.47-13.5-12.48S332,204.29,332,204.29Z",
    style: {
      fill: "#076760",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.92,246.35l5.72,22.9s-1.31,3.42-.31,4.35a3.29,3.29,0,0,1,1,2.12s-.83,3.41.2,5,5.73,35.43,5.73,35.43-3.93,4-3.87,5.69a14.22,14.22,0,0,1-.77,4.85c-.43,1.23-2,3.7-1.29,3.91s3.57-1.11,3.77-2.08a9.74,9.74,0,0,1,.88-2.2l.65-1.71a62.35,62.35,0,0,1,.27,6.73,10.64,10.64,0,0,1-1.06,3.66c-.68,1.23-2.28,3.22-1.06,3.65s4.88-4.52,4.88-4.52a10.57,10.57,0,0,0,3.08-1.33c1.64-1,3-4.45,3.15-5.67s0-6,0-6.74-1-6.23-1-6.23,2.84-25.64,2.56-32.86a132.84,132.84,0,0,0-1.26-13.44l-.94-5.5s-2.17-30.75-5.56-37.37-8.9-11.69-13.27-12.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,245.61l6.13,23.64s-1.31,3.42-.31,4.35a3.29,3.29,0,0,1,1,2.12s-.83,3.41.2,5a11.11,11.11,0,0,1,.62,2.37c2.87-1.87,9.45-5.12,14.42.17a2.45,2.45,0,0,0,.88.64c0-1,0-1.9,0-2.6a132.84,132.84,0,0,0-1.26-13.44l-.94-5.5s-2.17-30.75-5.56-37.37-10.08-11.64-14.46-12.68",
    style: {
      fill: "#076760",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.49 237.29 284.8 262.51 298.37 261.99 291.44 235.39 276.49 237.29",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.07,267.23a2.37,2.37,0,0,0,.82-1c.51-1.34,1.38-3.06,1.38-3.06s4.25-1.86,4.8-2.26,4.26-1.48,4.78-2.44.51-1.52-1.35-.89-7.6,2.37-7.6,2.37.92-.41,1.65-.82,5.69-3.42,6.25-3.63.7-1.34.29-2.07-.73.4-2.4,1S285.9,257,285.9,257l3.29-2.38c.55-.4,5.53-2.66,5.53-2.66s1.47-.81,1.43-1.75-.6-1.1-1.16-.89-4.3.54-5.59,1.16-5.52,2.84-5.52,2.84l1.9-4.2s5.12-3.59,5.86-3.8,2.21-1.22,2-2-1.72-.87-1.72-.87-6.49,2.13-7.76,3.5-3.77,4.28-3.77,4.28a17.84,17.84,0,0,1-1.09-3.71c0-1.13-.12-3.19-.92-4.29s-1-.71-1-.71,0,6-.31,6.58,2.65,10,2.65,10l1.28,3.9a65.51,65.51,0,0,1-7.49.67c-1.88-.12-4.37,3.36-4.76,7.7a6.83,6.83,0,0,0,6.68,7.44c3.37-.14,5.89-2.86,7.14-4.6a15.11,15.11,0,0,0,1.89-4.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawMessengerRe8Bky);
export default __webpack_public_path__ + "static/media/undraw_messenger_re_8bky.4de17f284bd3c5d202072c7e9da89cee.svg";
export { ForwardRef as ReactComponent };